/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// Helper functions
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

class NoobiotikPacks extends HTMLElement {
  constructor() {
    super();
    this.bundleImages = document.querySelectorAll('[data-banner-pack-bundle-product-image]');
    this.bundleIcons = document.querySelectorAll('.bundle-icon-remove');
    this.bundleIcons.forEach((bundleIcon) => {
      bundleIcon.addEventListener('click', this.removeItemFromBundle.bind(this));
    });
    this.bundleDiscountPrice = document.querySelector('[data-banner-pack-bundle-price]');
    this.bundleOldPrice = document.querySelector('[data-banner-pack-bundle-discount]');

    this.addToCartBtn = this.querySelector('#addToCartBtn');
    this.addToCartBtn.addEventListener('click', this.addBundleToCart.bind(this));
    this.maxItems = parseInt(this.dataset.bundleMaxItems);

    this.priceDiscount = 0;
    this.priceOld = 0;
    this.currentCards = [];

    // Open Info Drawer
    this.querySelectorAll('.product-item__aspect-ratio.aspect-ratio').forEach((prodImg) => {
      prodImg.addEventListener('click', this.showInfoAfterImgClick.bind(this));
    });
  }

  BundleUpdateUnsubscriber = undefined;

  connectedCallback() {
    //   this.validateQtyRules();
    this.BundleUpdateUnsubscriber = subscribe('update-noobiotik-bundle', this.updateBundle.bind(this));
  }

  disconnectedCallback() {
    if (this.BundleUpdateUnsubscriber) {
      this.BundleUpdateUnsubscriber();
    }
  }

  updateUI() {
    this.updateImageBundle();
    this.updatePrice();
    this.addToCartBtn.disabled = this.getNbItems(this.currentCards) <= 1;
  }

  updateBundle(data) {
    // Quantity

    let notAlreadyInBundle = true;
    for (let [index, item] of this.currentCards.entries()) {
      if (item.id === data.id) {
        notAlreadyInBundle = false;
        data.type === 'add' ? (item.quantity += 1) : (item.quantity -= 1);
        item.quantity = item.quantity < 0 ? 0 : item.quantity;
        break;
      }
    }
    if (notAlreadyInBundle && data.type === 'add' && this.currentCards.length <= this.maxItems - 1) {
      data.quantity = 1;
      delete data.type;
      this.currentCards.push(data);
    }

    this.currentCards = this.currentCards.filter((item) => item.quantity > 0);
    // console.log(this.currentCards);

    this.updateUI();
  }

  updateImageBundle() {
    for (let e = 0; e < this.bundleImages.length; e++) {
      this.bundleImages[e].replaceChildren();
      this.bundleIcons[e].hidden = true;
    }

    for (let e = 0; e < this.currentCards.length; e++) {
      if (this.currentCards[e].quantity > 0) {
        this.bundleImages[
          e
        ].innerHTML = `<div class="bubble-countheader__cart-count header__cart-count--floating bubble-count bundle-count">${this.currentCards[
          e
        ].quantity.toString()}</div>`;

        var r = document.createElement('img');
        r.src = this.currentCards[e].image;
        this.bundleImages[e].appendChild(r);

        this.bundleImages[e].classList.add('active');
        this.bundleIcons[e].hidden = false;
      }
    }
  }

  getNbItems(cart) {
    let total = 0;
    for (let item of cart) {
      total += item.quantity;
    }
    return total;
  }

  updatePrice() {
    var n = 0;
    this.currentCards.forEach((e) => {
      n += parseFloat(e.price * e.quantity);
    });

    this.priceDiscount = n;
    this.priceOld = n;

    if (this.getNbItems(this.currentCards) == 2) {
      this.priceDiscount = n - (10 * n) / 100;
    }
    if (this.getNbItems(this.currentCards) >= 3) {
      this.priceDiscount = n - (15 * n) / 100;
    }

    this.bundleDiscountPrice.innerHTML = (this.priceDiscount / 100).toFixed(2).toString().replace('.', ',') + '€';
    this.bundleOldPrice.innerHTML = (this.priceOld / 100).toFixed(2).toString().replace('.', ',') + '€';

    if (this.priceDiscount === this.priceOld) {
      this.bundleDiscountPrice.innerHTML = '';
      this.bundleOldPrice.innerHTML = '';
    }
  }

  addBundleToCart(event) {
    event.preventDefault();
    this.addToCartBtn.disabled = true;
    this.addToCartBtn.setAttribute('aria-busy', 'true');
    const payload = {
      items: this.currentCards,
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then(async (e) => {
        const n = await e.json();
        fetch(window.themeVariables.routes.cartUrl + '.js').then(async (e) => {
          e = await e.json();
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: e,
              },
            })
          ),
            (e.sections = n.sections),
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', {
                bubbles: true,
                detail: {
                  cart: e,
                  openMiniCart: true,
                },
              })
            );
        });
      })
      .catch((e) => {
        console.log('Error: ', e);
      });

    this.addToCartBtn.setAttribute('aria-busy', 'false');
    setTimeout(() => {
      this.resetValues();
    }, 250);
  }

  resetValues() {
    document.querySelectorAll('pack-quantity-selector').forEach((item) => {
      item.querySelector('input').quantity = 0;
    });
    this.currentCards = [];
    this.updateUI();
  }

  removeItemFromBundle(event) {
    event.preventDefault();

    let bundleIndex = event.target.dataset.bundleIndex;
    let targetProdId = this.currentCards[bundleIndex].id;

    this.currentCards.splice(bundleIndex, 1);
    document.querySelector(`pack-quantity-selector input[data-bundle-prod-id='${targetProdId}']`).quantity = 0;

    this.updateUI();
  }

  showInfoAfterImgClick(event) {
    event.preventDefault();

    // event.currentTarget.querySelector("button").click();
    // let targetButton = event.target.querySelector("button")._onButtonClick()

    if (window.matchMedia(window.themeVariables.breakpoints.tabletAndUp).matches) {
      window.matchMedia('(pointer: fine)').matches == true
        ? event.currentTarget.parentNode.querySelector('button.button--outline').click()
        : event.currentTarget.parentNode.querySelector('button.hidden-no-touch').click();
    } else if (window.matchMedia(window.themeVariables.breakpoints.phone).matches) {
      event.currentTarget.parentNode.querySelector('button.hidden-tablet-and-up').click();
    }
  }
}

customElements.define('noobiotik-packs', NoobiotikPacks);

// Tweak some apps behaviour

// Remove Z-index for "recompense widget"
// const observer = new MutationObserver(function (mutations_list) {
//   mutations_list.forEach(function (mutation) {
//     mutation.addedNodes.forEach(function (added_node) {
//       if (added_node.id == 'smile-ui-lite-container') {
//         added_node.style.zIndex = 2;
//         observer.disconnect();
//       }
//     });
//   });
// });

// observer.observe(document.querySelector('body'), {
//   subtree: false,
//   childList: true,
// });

// window.addEventListener('smile-ui-loaded', () => {
//   setTimeout(() => {
//     document.querySelector('#smile-ui-container').style.zIndex = 3;
//   }, 1000);
// });

// uP 09-2024

document.querySelectorAll('.up-posologie__video native-video').forEach((nativeVideo) => {
  nativeVideo.addEventListener('click', (event) => {
    if (event.target.nodeName === 'VIDEO') {
      const video = event.target;
      if (video.currentTime > 0 && video.readyState > video.HAVE_CURRENT_DATA) {
        video.paused ? video.play() : video.pause();
      }
    }
  });
});

var upTestimonialList = class extends HTMLElement {
  connectedCallback() {
    this.listItems = Array.from(this.querySelectorAll('.up-testimonial__card'));
    this.listWrapperElement = this.querySelector('.up-testimonial-cards__list-wrapper');
    if (this.listItems.length > 1) {
      this.addEventListener('prev-next:prev', this.previous.bind(this));
      this.addEventListener('prev-next:next', this.next.bind(this));
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => this.select(event.target.index, !event.detail.load));
      }
    }
  }
  previous() {
    this.select([...this.listItems].reverse().find((item) => item.isOnLeftHalfPartOfScreen)?.index);
  }
  next() {
    this.select(this.listItems.findIndex((item) => item.isOnRightHalfPartOfScreen));
  }
  select(index, animate = true) {
    if (!this.listItems[index]) return;
    const boundingRect = this.listItems[index].getBoundingClientRect();
    this.listWrapperElement.scrollBy({
      behavior: animate ? 'smooth' : 'auto',
      left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2),
    });
  }
};
window.customElements.define('up-testimonial-list', upTestimonialList);

var upTestimonialStories = class extends HTMLElement {
  connectedCallback() {
    this.listItems = Array.from(this.querySelectorAll('.up-testimonial__story'));
    this.listWrapperElement = this.querySelector('.up-testimonial-stories__list-wrapper');
    if (this.listItems.length > 1) {
      this.addEventListener('prev-next:prev', this.previous.bind(this));
      this.addEventListener('prev-next:next', this.next.bind(this));
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => this.select(event.target.index, !event.detail.load));
      }
    }
  }
  previous() {
    this.select([...this.listItems].reverse().find((item) => item.isOnLeftHalfPartOfScreen)?.index);
  }
  next() {
    this.select(this.listItems.findIndex((item) => item.isOnRightHalfPartOfScreen));
  }
  select(index, animate = true) {
    if (!this.listItems[index]) return;
    const boundingRect = this.listItems[index].getBoundingClientRect();
    this.listWrapperElement.scrollBy({
      behavior: animate ? 'smooth' : 'auto',
      left: Math.floor(boundingRect.left - window.innerWidth / 2 + boundingRect.width / 2),
    });
  }
};
window.customElements.define('up-testimonial-stories', upTestimonialStories);

const estimateDateBlock = document.querySelector('[data-block-type="up-shipping-date"]');
if (estimateDateBlock) {
  document.addEventListener('variant:change', (event) => {
    if (!event.detail.variant || !event.detail.variant['available']) {
      estimateDateBlock.classList.add('hidden');
    } else {
      estimateDateBlock.classList.remove('hidden');
    }
  });
}

// Testimonials slider
var upTestimonialCarousel = class extends CustomHTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('up-testimonial-carousel-item'));
    this.pageDotsElements = Array.from(this.querySelectorAll('page-dots'));
    this.hasPendingTransition = false;
    if (this.items.length > 1) {
      this.addEventListener('swiperight', this.prev.bind(this));
      this.addEventListener('swipeleft', this.next.bind(this));
      this.addEventListener('page-dots:changed', (event) => this.select(event.detail.index, true));
      if (Shopify.designMode) {
        //this.addEventListener('shopify:block:deselect', this.startPlayer.bind(this));
        this.addEventListener('shopify:block:select', (event) => {
          this.pausePlayer();
          this.select(event.target.index, !event.detail.load);
        });
      }

      this.addEventListener('mousedown', this.pausePlayer.bind(this));
      this.addEventListener('touchend', this.pausePlayer.bind(this));
      this.startPlayer();
    }
    const scrollerElement = this.items[0].parentElement;
    this.intersectionObserver = new IntersectionObserver(this._onVisibilityChanged.bind(this), {
      root: scrollerElement,
      rootMargin: `${scrollerElement.clientHeight}px 0px`,
      threshold: 0.8,
    });
    this.items.forEach((item) => this.intersectionObserver.observe(item));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.intersectionObserver.disconnect();
  }
  get selectedIndex() {
    return this.items.findIndex((item) => item.selected);
  }
  prev(shouldAnimate = true) {
    this.select(Math.max(this.selectedIndex - 1, 0), shouldAnimate);
  }
  next(shouldAnimate = true) {
    this.select(Math.min(this.selectedIndex + 1, this.items.length - 1), shouldAnimate);
  }
  select(index, shouldAnimate = true) {
    if (this.hasPendingTransition) return;
    this.hasPendingTransition = true;
    this.pausePlayer();

    const clampIndex = Math.max(0, Math.min(index, this.items.length));
    const selectedElement = this.items[clampIndex];
    this._adjustNavigationForElement(selectedElement);
    if (shouldAnimate) {
      this.items.forEach((item) => this.intersectionObserver.unobserve(item));
      setInterval(() => {
        this.items.forEach((item) => this.intersectionObserver.observe(item));
      }, 800);
    }
    this.items.forEach((item, loopIndex) => (item.selected = loopIndex === clampIndex));
    const direction = window.themeVariables.settings.direction === 'ltr' ? 1 : -1;
    selectedElement.parentElement.scrollTo({
      left: direction * (selectedElement.clientWidth * clampIndex),
      behavior: shouldAnimate ? 'smooth' : 'auto',
    });
    this.hasPendingTransition = false;
    this.startPlayer();
  }
  _adjustNavigationForElement(selectedElement) {
    this.items.forEach((item) => (item.selected = selectedElement === item));
    this.pageDotsElements.forEach((pageDot) => (pageDot.selectedIndex = selectedElement.index));
  }
  _onVisibilityChanged(entries) {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        this._adjustNavigationForElement(entry.target);
        break;
      }
    }
  }

  pausePlayer() {
    clearTimeout(this._timeout);
    this._timeout = null;
  }
  startPlayer() {
    if (this._timeout) this.pausePlayer();
    this._timeout = setTimeout(() => {
      this.selectedIndex == this.items.length - 1 ? this.select(0) : this.next();
    }, this.dataset.cycleSpeed || 4e3);
  }
};

var upTestimonialCarouselItem = class extends CustomHTMLElement {
  static get observedAttributes() {
    return ['hidden'];
  }
  get index() {
    return [...this.parentNode.children].indexOf(this);
  }
  get selected() {
    return !this.hasAttribute('hidden');
  }
  set selected(value) {
    this.hidden = !value;
  }
};
window.customElements.define('up-testimonial-carousel-item', upTestimonialCarouselItem);
window.customElements.define('up-testimonial-carousel', upTestimonialCarousel);

// Timer
if (!customElements.get('up-countdown')) {
  class upCountdown extends HTMLElement {
    constructor() {
      super();

      this.endDate = new Date(this.dataset.endDate).getTime();
      this.state = null;

      this.second = 1000;
      this.minute = this.second * 60;
      this.hour = this.minute * 60;
      this.day = this.hour * 24;

      // UI
      this.countdown = this.querySelector('.up-countdown__countdown');
      this.countdownDigits = {
        days: this.countdown.querySelector('[data-days]'),
        hours: this.countdown.querySelector('[data-hours]'),
        minutes: this.countdown.querySelector('[data-minutes]'),
        seconds: this.countdown.querySelector('[data-seconds]'),
      };
    }

    connectedCallback() {
      if (!this.dataset.endDate) return;

      Object.values(this.countdownDigits).forEach((digit) => {
        digit.removeAttribute('reveal-visibility');
      });
      this.updateComponent();
      this.timer = setInterval(this.updateComponent.bind(this), 1000);
    }

    updateComponent() {
      this.updateState();
      if (this.state != this.lastState) this.updateView();
      if (this.state === 'during') this.updateCountdown();
      if (this.state === 'after') clearInterval(this.timer);
    }

    updateState() {
      this.lastState = this.state;
      this.state = this.endDate - new Date().getTime() > 0 ? 'during' : 'after';
    }

    updateView() {
      this.state === 'during' ? this.countdown.classList.remove('hidden') : this.countdown.classList.add('hidden');
    }

    updateCountdown() {
      const t = this.endDate - new Date().getTime();

      this.countdownDigits.days.innerText = String(Math.floor(t / this.day)).padStart(2, '0');
      this.countdownDigits.hours.innerText = String(Math.floor((t % this.day) / this.hour)).padStart(2, '0');
      this.countdownDigits.minutes.innerText = String(Math.floor((t % this.hour) / this.minute)).padStart(2, '0');
      this.countdownDigits.seconds.innerText = String(Math.floor((t % this.minute) / this.second)).padStart(2, '0');
    }
  }
  customElements.define('up-countdown', upCountdown);
}
